import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { FlashMessageDto, FlashMessageDtoImpl } from '../dto/flashmessage/get/flashmessagedto';
import { GetDedicateFlashMessageRequest } from '../api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesrequest';
import { GetDedicateFlashMessageResponse, GetDedicateFlashMessageResponseDtoImpl } from '../api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesresponse';
import { DedicateFlashMessageBuilder } from '../dto/flashmessage/dedicate/dedicateflashmessagebuilder';

export class GetDedicateFlashMessageAPIProcessorImpl extends APIProcessorImpl<GetDedicateFlashMessageRequest, GetDedicateFlashMessageResponse>
{
    // execute(): void 
    // {
    //     let response = new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, "Get GetDedicateFlashMessage Success");
    //       response.setFlashMessageResponseDtos(this.getFlashMessageDto());
        
    //     this.getAPISuccess(response);
    // }
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) 
            {
                if(+responseMapper.getStatusCodeOutside() === 0)
                {
                    let response = new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, "Get GetDedicateFlashMessage Success");
                    response.setDedicateFlashDtoDtos(new DedicateFlashMessageBuilder(responseMapper.getResponseMap()).buildAll());
                    
                    this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.NO_CONTENT)
                {
                    this.getAPISuccess(new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.INTERNAL_SERVER_ERROR)
                {
                    this.getAPIFailure(new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
                }
                else
                {
                    this.getAPIFailure(new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, responseMapper.getStatusMsg()));
                }
                
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        this.getAPIFailure(new GetDedicateFlashMessageResponseDtoImpl(APIFeatures.GET_DEDICATE_FLASH_MESSAGE, responseMapper.getStatusMsg()));
    }


    getFlashMessageDto():FlashMessageDto[]
    {
        let data1 = new FlashMessageDtoImpl();
        data1.setMsisdn("");
        data1.setId("1");
        data1.setPlanName("Monthly");
        data1.setStatusMessage("Busy right now , will callback");

        return [data1];
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getdedicateflashmessagesapiprocessor.tsx